import { Component } from '@angular/core';
const { version: appVersion } = require('../../../../package.json');

@Component({
	selector: 'app-version-page',
	templateUrl: './version-page.component.html',
	styleUrls: ['./version-page.component.scss'],
})
export class VersionPageComponent {
	appVersion = 'teste';

	constructor() {
		this.appVersion = appVersion;
	}
}
